import React from 'react'
import { Link } from 'react-router-dom';

function OffCanvasMenu() {
    const offCanvasOnClick = () => {
        const offcanvas = document.querySelector('[data-bs-dismiss="offcanvas"]');
        if (offcanvas) {
            offcanvas.click();
        }
    };

    return (
        <div className="offcanvas offcanvas-start canvas-mb" id="mobileMenu">
            <span className="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
            <div className="mb-canvas-content">
                <div className="mb-body">
                    <ul className="nav-ul-mb" id="wrapper-menu-navigation">
                        <li className="nav-mb-item">
                            <Link to="/" className="mb-menu-link" onClick={offCanvasOnClick}>
                                Home
                            </Link>
                        </li>
                        <li className="nav-mb-item">
                            <Link to="/shop" className="mb-menu-link" onClick={offCanvasOnClick}>
                                Shop
                            </Link>
                        </li>
                        <li className="nav-mb-item">
                            <Link to="/about" className="mb-menu-link" onClick={offCanvasOnClick}>
                                About
                            </Link>
                        </li>
                        <li className="nav-mb-item">
                            <Link to="/contact" className="mb-menu-link" onClick={offCanvasOnClick}>
                                Contact
                            </Link>
                        </li>
                    </ul>
                    <div className="mb-other-content">
                        <div className="mb-notice">
                            <a href="contact-1.html" className="text-need">
                                Need help ?
                            </a>
                        </div>
                        <ul className="mb-info">
                            <li>
                                Barkati Creation, <br />
                                Shree Arihant Complex, C5, 2nd floor, Gala no. 4,
                                Reti Bunder Road, Near Shilpa hotel
                                Kalher Pipe Line, Kalher,
                                BHIWANDI
                            </li>
                            <li>
                                Email: <b>info@geniusbaby.com</b>
                            </li>
                            <li>
                                Phone: <b>(+91) 808-037-7402</b>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="mb-bottom">
                    <a href="login" className="site-nav-icon">
                        <i className="icon icon-account"></i>Login
                    </a>
                </div>
            </div>
        </div>
    )
}

export default OffCanvasMenu